import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Invoice } from '~hooks/useInvoices/models';

import { FlexColumn } from '../../styled';

interface TruckColumnProps {
  invoice: Invoice;
  sx?: SxProps<Theme>;
}

const TruckColumn = ({ invoice, sx }: TruckColumnProps) => {
  const { equipment } = invoice;

  return (
    <Box sx={sx}>
      <FlexColumn>
        <OverflowAwareText fontSize="inherit">{equipment?.name ?? '-'}</OverflowAwareText>
      </FlexColumn>
    </Box>
  );
};

export default TruckColumn;
